export function spSignUp() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_sign_up'
    });
}
